<template>
  <div class="shenyunjie-chart-spectrum" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import merge from "deepmerge";

export default {
  name: "YunJieChartSpectrum",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    frequency: {
      type: Number,
      default: null
    },
    amplitude: {
      type: Number,
      default: null
    },
    xData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    yData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    unit: {
      type: String,
      default: ""
    },
    tooltip: {
      type: Boolean,
      default: true
    },
    precision: {
      type: Number,
      default: 8
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      defaultOption: {
        grid: {
          top: 48,
          bottom: 32,
          left: 56,
          right: 20
        },
        title: {
          left: "center"
        },
        xAxis: {
          type: "value",
          name: "单位：Hz",
          nameLocation: "center"
        },
        yAxis: {
          type: "value"
        },
        series: [{
          type: "line",
          symbol: "none",
          lineStyle: {
            width: 1
          }
        }]
      },
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeSpectrum);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeSpectrum() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        let subtext = "";
        if (self.frequency != null && self.amplitude != null) {
          subtext = `主频：${self.frequency} Hz；幅值：${self.amplitude} ${self.unit}`;
        } else if (self.frequency != null) {
          subtext = `主频：${self.frequency} Hz`;
        } else if (self.amplitude != null) {
          subtext = `幅值：${self.amplitude} ${self.unit}`;
        }
        // 配置汇总
        let parameter = {
          title: {
            text: self.title,
            subtext: subtext
          },
          yAxis: {
            name: self.unit ? `单位：${self.unit}` : ""
          },
          tooltip: {
            show: self.tooltip,
            trigger: "axis",
            formatter: function (params) {
              let str = "";
              params.forEach((item, idx) => {
                if (idx === 0) {
                  str += `幅值：${item.data[1].toFixed(self.precision)} ${self.unit}<br/>`;
                }
                str += `${item.marker} 频率: ${parseFloat(item.data[0]).toFixed(2)} Hz`;
                str += idx === params.length - 1 ? "" : "<br/>";
              });
              return str;
            }
          }
        };
        let opt = merge(self.defaultOption, parameter);
        let datas = [];
        for (let i = 0; i < self.xData.length; i++) {
          datas.push([self.xData[i], self.yData[i]]);
        }
        opt.series[0].data = datas;
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeSpectrum);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    frequency() {
      this.init();
    },
    amplitude() {
      this.init();
    },
    xData: {
      deep: true,
      handler(xData) {
        this.init();
      }
    },
    yData: {
      deep: true,
      handler(yData) {
        this.init();
      }
    },
    unit() {
      this.init();
    },
    tooltip() {
      this.init();
    },
    precision() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-spectrum {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/spectrum.vue